export function isAdminUser(): boolean {
  try {
    const raw = localStorage.getItem('userDetails');
    const parsed = raw ? JSON.parse(raw) : null;
    if (!parsed) return false;
    const roles = parsed?.roles ?? parsed?.role ?? parsed?.authorities ?? [];
    const arr = Array.isArray(roles) ? roles : roles ? [roles] : [];
    return (
      parsed?.isAdmin === true ||
      arr.map((r: any) => String(r || '').toUpperCase()).some((r: string) => r.includes('ADMIN')) ||
      String(parsed?.userType || parsed?.type || '').toUpperCase().includes('ADMIN')
    );
  } catch {
    return false;
  }
}
